"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drm = void 0;
var constants_1 = require("./constants");
var utilities_1 = require("./utilities");
var Drm = (function () {
    function Drm(videoApiEndpoint) {
        var _this = this;
        this.init = function (playlist) {
            if (Array.isArray(playlist)) {
                playlist.forEach(function (playlistItem) { return _this.setPlaylistItem(playlistItem); });
            }
        };
        this.setPlaylistItem = function (playlistItem) {
            if (!Array.isArray(playlistItem.sources)) {
                return;
            }
            playlistItem.sources.forEach(function (source) {
                if (source.drm) {
                    var drmType = Object.keys(source.drm)[0];
                    var drmSource = source.drm[drmType];
                    switch (drmType) {
                        case constants_1.DRM_PROVIDERS.WIDEVINE:
                        case constants_1.DRM_PROVIDERS.FAIRPLAY:
                        case constants_1.DRM_PROVIDERS.PLAYREADY:
                            _this[drmType](drmSource);
                            break;
                        default:
                            break;
                    }
                }
            });
        };
        this.widevine = function (drmSource) {
            var source = drmSource;
            source.licenseRequestFilter = function (request, drmInfo) { return __awaiter(_this, void 0, void 0, function () {
                var message;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            drmInfo.videoRobustness = 'SW_SECURE_CRYPTO';
                            drmInfo.audioRobustness = 'SW_SECURE_CRYPTO';
                            request.headers['Content-Type'] = 'application/json';
                            message = Drm.decodeMessage(new Uint8Array(request.body));
                            request.body = JSON.stringify({
                                getRawWidevineLicense: {
                                    releasePid: source.releasePid,
                                    widevineChallenge: message,
                                },
                            });
                            return [4, this.licenseRequestInvocation({
                                    drmProvider: constants_1.DRM_PROVIDERS.WIDEVINE,
                                    request: request,
                                })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
        };
        this.fairplay = function (drmSource) {
            var spcMessage = null;
            var source = drmSource;
            source.licenseResponseType = 'json';
            source.licenseRequestMessage = function (message) {
                spcMessage = Drm.base64EncodeUint8Array(message);
            };
            source.extractContentId = function () { return source.releasePid; };
            source.licenseRequestFilter = function (request) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            request.body = JSON.stringify({
                                getFairplayLicense: {
                                    releasePid: source.releasePid,
                                    spcMessage: spcMessage,
                                },
                            });
                            return [4, this.licenseRequestInvocation({
                                    drmProvider: constants_1.DRM_PROVIDERS.FAIRPLAY,
                                    request: request,
                                })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            source.licenseResponseFilter = function (response) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    response.data = Drm.arrayBufferFromBase64(response.data.getFairplayLicenseResponse.ckcResponse);
                    return [2];
                });
            }); };
            source.licenseResponseMessage = function (message) {
                return new window.Blob([message], { type: 'application/octet-binary' });
            };
        };
        this.playready = function (drmSource) {
            var source = drmSource;
            source.licenseRequestFilter = function (request, drmInfo) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.licenseRequestInvocation({
                                drmProvider: constants_1.DRM_PROVIDERS.PLAYREADY,
                                request: request,
                            })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
        };
        this.licenseRequestInvocation = function (_a) {
            var drmProvider = _a.drmProvider, request = _a.request;
            return __awaiter(_this, void 0, void 0, function () {
                var drmToken, err_1, DrmTokenDecoded, AccountUrl;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4, utilities_1.fetchDrmToken({ videoApiEndpoint: this.videoApiEndpoint })];
                        case 1:
                            drmToken = _b.sent();
                            if (!drmToken) {
                                throw "Couldn't obtain token";
                            }
                            return [3, 3];
                        case 2:
                            err_1 = _b.sent();
                            console.error(err_1);
                            return [2, false];
                        case 3:
                            switch (drmProvider) {
                                case 'fairplay':
                                case 'widevine':
                                    request.headers['Authorization'] = "Basic " + drmToken;
                                    break;
                                default:
                                    DrmTokenDecoded = atob(drmToken).split(':');
                                    AccountUrl = DrmTokenDecoded.slice(0, 2).join(':');
                                    request.uris[0] += "&account=" + AccountUrl + "&auth=" + DrmTokenDecoded[2];
                                    break;
                            }
                            return [2, true];
                    }
                });
            });
        };
        this.videoApiEndpoint = videoApiEndpoint;
    }
    Drm.arrayBufferFromBase64 = function (str) {
        var bytes = window.atob(str.replace(/-/g, '+').replace(/_/g, '/'));
        var result = new Uint8Array(bytes.length);
        for (var i = 0; i < bytes.length; ++i) {
            result[i] = bytes.charCodeAt(i);
        }
        return result;
    };
    Drm.decodeMessage = function (a) {
        var b = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        for (var c, d, e, f, g, h = '', i = a, j = i.byteLength, k = j % 3, l = j - k, m = 0; m < l; m += 3)
            (g = (i[m] << 16) | (i[m + 1] << 8) | i[m + 2]),
                (c = (16515072 & g) >> 18),
                (d = (258048 & g) >> 12),
                (e = (4032 & g) >> 6),
                (f = 63 & g),
                (h += b[c] + b[d] + b[e] + b[f]);
        return (1 == k
            ? ((g = i[l]), (c = (252 & g) >> 2), (d = (3 & g) << 4), (h += b[c] + b[d] + '=='))
            : 2 == k &&
                ((g = (i[l] << 8) | i[l + 1]),
                    (c = (64512 & g) >> 10),
                    (d = (1008 & g) >> 4),
                    (e = (15 & g) << 2),
                    (h += b[c] + b[d] + b[e] + '=')),
            h);
    };
    Drm.base64EncodeUint8Array = function (input) {
        var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        var output = '';
        var chr1;
        var chr2;
        var chr3;
        var enc1;
        var enc2;
        var enc3;
        var enc4;
        var i = 0;
        while (i < input.length) {
            chr1 = input[i++];
            chr2 = i < input.length ? input[i++] : Number.NaN;
            chr3 = i < input.length ? input[i++] : Number.NaN;
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (Number.isNaN(chr2)) {
                enc3 = 64;
                enc4 = 64;
            }
            else if (Number.isNaN(chr3)) {
                enc4 = 64;
            }
            output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
        }
        return output;
    };
    return Drm;
}());
exports.Drm = Drm;
